import { computed } from '@ember/object';
import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
import { MULTIPLE_IMAGES_API_VERSION } from '@square/dashboard-items-data/adapters/connect/image';
import { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
export default CatalogObjectAdapter.extend({
  headers: computed(function () {
    return {
      'Square-Version': MULTIPLE_IMAGES_API_VERSION
    };
  }),
  _modelNameForObjectType(type) {
    return this.store.serializerFor('connect/catalog-object')._modelNameForObjectType(CatalogObjectType.SUBSCRIPTION_PLAN_VARIATION ? CatalogObjectType.SUBSCRIPTION_PLAN : type);
  }
});